export function createIntercom() {
    let Intercom = function () {
        Intercom.c(arguments);
    };

    Intercom.q = [];
    Intercom.c = function (args) {
        Intercom.q.push(args);
    };
    return Intercom;
}
